<template>
  <div class="card mgt-20px">
    <header class="header-card" >
      <p>{{ $t('addEditMarche.information.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field
            v-if="!detail"
            :label="$t('addEditMarche.information.code')">
            <b-input v-model.trim="marche.code"></b-input>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('detailMarche.information.code') }}
            </p>
            <p class="has-text-weight-bold">{{ marche.code }}</p>
          </div>
        </div>
        <div class="column is-3">
          <b-field
            v-if="!detail" class="obligatoire"
            :label="$t('addEditMarche.information.libelle')">
            <b-input v-model.trim="marche.libelle"></b-input>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('detailMarche.information.libelle') }}
            </p>
            <p class="has-text-weight-bold">{{ marche.libelle }}</p>
          </div>
        </div>
        <div class="column is-3">
          <b-field
            v-if="!detail"
            :label="$t('addEditMarche.information.dateSignature')">
            <div class="columns is-vcentered" >
              <b-datepicker
                v-model="marche.dateSignature"
                class="column"
                icon="calendar-today"
                position="is-bottom-right"
                nearby-selectable-month-days
                show-week-number editable>
              </b-datepicker>
            </div>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('detailMarche.information.dateSignature') }}
            </p>
            <p class="has-text-weight-bold">
              {{ marche.dateSignature | formatDate }}
            </p>
          </div>
        </div>
        <div class="column is-3">
          <b-field
            v-if="!detail"
            :label="$t('addEditMarche.information.dateDebut')"
            class="obligatoire">
            <div class="columns is-vcentered" >
              <b-datepicker
                v-model="marche.dateDebut"
                class="column"
                icon="calendar-today"
                position="is-bottom-right"
                nearby-selectable-month-days
                show-week-number editable>
              </b-datepicker>
            </div>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('detailMarche.information.dateDebut') }}
            </p>
            <p class="has-text-weight-bold">
              {{ marche.dateDebut | formatDate }}
            </p>
          </div>
        </div>
        <div class="column is-3">
          <b-field
            v-if="!detail"
            :label="$t('addEditMarche.information.dateFin')">
            <div class="columns is-vcentered" >
              <b-datepicker
                v-model="marche.dateFin"
                class="column"
                icon="calendar-today"
                position="is-bottom-right"
                nearby-selectable-month-days
                show-week-number editable>
              </b-datepicker>
            </div>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('detailMarche.information.dateFin') }}
            </p>
            <p class="has-text-weight-bold">
              {{ marche.dateFin | formatDate }}
            </p>
          </div>
        </div>
        <div class="column is-3 pdb-0">
          <b-field
            v-if="!detail"
            :label="$t('addEditMarche.information.reconductibleTacitement')">
            <b-select v-model="marche.reconductibleTacitement">
              <option :value="true">{{ $t('general.oui') }}</option>
              <option :value="false">{{ $t('general.non') }}</option>
            </b-select>
          </b-field>
          <div v-else>
            <p class="has-text-default is-italic">
              {{ $t('detailMarche.information.reconductibleTacitement') }}
            </p>
            <p class="has-text-weight-bold">
              {{ $t(`general.${marche.reconductibleTacitement ? 'oui' : 'non'}`) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MARCHE } from '@/configuration/achat/permissionsConf';

export default {
  props: {
    marche: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
  },
  data() {
    return {
      permissionTiers: MARCHE,
    };
  },
};
</script>
